export const SNOWPLOW_SCHEME = {
  VIEW_PAGE: `iglu:com.29cm/view_page/jsonschema/1-0-0`,
  CLICK_BUTTON: `iglu:com.29cm/click_button/jsonschema/1-0-1`,
  CLICK_ITEM: `iglu:com.29cm/click_item/jsonschema/2-0-0`,
  CLICK_CONTENT: `iglu:com.29cm/click_content/jsonschema/2-0-0`,
  IMPRESSION_ITEM: `iglu:com.29cm/impression_item/jsonschema/1-0-0`,
  IMPRESSION_CONTENT: `iglu:com.29cm/impression_content/jsonschema/1-0-0`,
  CLICK_BUTTON_TEMP: `iglu:com.29cm/click_button_temp/jsonschema/1-0-0`,
  LIKE_ITEM: `iglu:com.29cm/like_item/jsonschema/2-0-0`,
} as const;
